var _defs, _ellipse, _rect, _g, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidebarFooter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 280 180",
    fill: "none",
    preserveAspectRatio: "xMidYMax meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "tankGrad",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#1e3a6e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55%",
    stopColor: "#152a52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0c1a38"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tankGlow",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#5b7cfa",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#6ea8ff",
    stopOpacity: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#5b7cfa",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "truckBody",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#243b6b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#152447"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "purpleGlow",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#3d2a7a",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#2a1f6b",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "rimGlow",
    cx: "50%",
    cy: "50%",
    r: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "60%",
    stopColor: "#7eb6ff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#8ec5ff",
    stopOpacity: 0.7
  })))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 140,
    cy: 168,
    rx: 130,
    ry: 14,
    fill: "#1a1048",
    opacity: 0.55
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 150,
    width: 280,
    height: 30,
    fill: "url(#purpleGlow)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(18,48)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 28,
    cy: 8,
    rx: 26,
    ry: 8,
    fill: "#2a4a7a"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 8,
    width: 52,
    height: 100,
    fill: "url(#tankGrad)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 28,
    cy: 108,
    rx: 26,
    ry: 8,
    fill: "#0d1c38"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 28,
    cy: 8,
    rx: 26,
    ry: 8,
    fill: "none",
    stroke: "#6ea8ff",
    strokeWidth: 1.2,
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 40 H52",
    stroke: "url(#tankGlow)",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 70 H52",
    stroke: "url(#tankGlow)",
    strokeWidth: 1.2,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 0,
    width: 12,
    height: 6,
    rx: 1,
    fill: "#3d6bb0"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(68,58)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 24,
    cy: 7,
    rx: 22,
    ry: 7,
    fill: "#2a4a7a"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 7,
    width: 44,
    height: 92,
    fill: "url(#tankGrad)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 24,
    cy: 99,
    rx: 22,
    ry: 7,
    fill: "#0d1c38"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 24,
    cy: 7,
    rx: 22,
    ry: 7,
    fill: "none",
    stroke: "#6ea8ff",
    strokeWidth: 1.1,
    opacity: 0.65
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 35 H46",
    stroke: "url(#tankGlow)",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 62 H46",
    stroke: "url(#tankGlow)",
    strokeWidth: 1,
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 0,
    width: 12,
    height: 5,
    rx: 1,
    fill: "#3d6bb0"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(112,52)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 22,
    cy: 7,
    rx: 20,
    ry: 7,
    fill: "#2a4a7a"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 7,
    width: 40,
    height: 98,
    fill: "url(#tankGrad)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 22,
    cy: 105,
    rx: 20,
    ry: 7,
    fill: "#0d1c38"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 22,
    cy: 7,
    rx: 20,
    ry: 7,
    fill: "none",
    stroke: "#7eb6ff",
    strokeWidth: 1.1,
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 38 H42",
    stroke: "url(#tankGlow)",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 68 H42",
    stroke: "url(#tankGlow)",
    strokeWidth: 1,
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 0,
    width: 12,
    height: 5,
    rx: 1,
    fill: "#3d6bb0"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(145,95)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 60,
    cy: 62,
    rx: 58,
    ry: 6,
    fill: "#0a1028",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 18,
    width: 78,
    height: 28,
    rx: 12,
    fill: "url(#truckBody)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8,
    cy: 32,
    rx: 7,
    ry: 14,
    fill: "#1b3158"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 86,
    cy: 32,
    rx: 7,
    ry: 14,
    fill: "#243b6b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 20 C30 14, 60 14, 80 20",
    stroke: "#7eb6ff",
    strokeWidth: 1.2,
    fill: "none",
    opacity: 0.65
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 32 H78",
    stroke: "#5b8fd4",
    strokeWidth: 0.8,
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 18,
    r: 3,
    fill: "#1e3a6e",
    stroke: "#6ea8ff",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 16,
    r: 3.5,
    fill: "#1e3a6e",
    stroke: "#6ea8ff",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 18,
    r: 3,
    fill: "#1e3a6e",
    stroke: "#6ea8ff",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 44,
    width: 70,
    height: 4,
    rx: 1,
    fill: "#152447"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88 46 L88 22 Q88 16 96 16 L112 16 Q118 16 118 24 L118 46 Z",
    fill: "#1f3560"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96 18 L110 18 Q114 18 114 24 L114 34 L96 34 Z",
    fill: "#4a7ec8",
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 42,
    width: 32,
    height: 6,
    fill: "#152447"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90 18 L96 18 L96 16 Q90 16 90 20 Z",
    fill: "#6ea8ff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 52,
    r: 9,
    fill: "#0d1528"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 52,
    r: 9,
    fill: "url(#rimGlow)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 52,
    r: 5,
    fill: "#1a2a48",
    stroke: "#6ea8ff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 52,
    r: 2,
    fill: "#3d6bb0"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 52,
    r: 9,
    fill: "#0d1528"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 52,
    r: 9,
    fill: "url(#rimGlow)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 52,
    r: 5,
    fill: "#1a2a48",
    stroke: "#6ea8ff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 52,
    r: 2,
    fill: "#3d6bb0"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 102,
    cy: 52,
    r: 9,
    fill: "#0d1528"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102,
    cy: 52,
    r: 9,
    fill: "url(#rimGlow)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102,
    cy: 52,
    r: 5,
    fill: "#1a2a48",
    stroke: "#6ea8ff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102,
    cy: 52,
    r: 2,
    fill: "#3d6bb0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarFooter);
export default __webpack_public_path__ + "static/media/sidebar-footer.ceebab8ecbc02a4903de3aacd1f9200e.svg";
export { ForwardRef as ReactComponent };